import api from '~/services';
import * as lib from '~/dependencies';
import log from '~/helpers/log';
import * as actionTypes from './actionTypes';

export const saveDraft = data => (dispatch, getState) => {
  const drafts = getState().draft.data;
  const verifyIfExist = drafts.findIndex(
    e => e.id === data.id && e.account === data.account
  );

  if (verifyIfExist === -1) {
    dispatch({
      type: actionTypes.ADD_DRAFT,
      payload: {
        data: [...drafts, data],
      },
    });
  } else {
    const newArray = drafts.filter(e => e.id !== data.id);
    dispatch({
      type: actionTypes.ADD_DRAFT,
      payload: {
        data: [...newArray, data],
      },
    });
  }
};

export const removeDraft = id => (dispatch, getState) => {
  const drafts = getState().draft.data;

  const newArray = drafts.filter(e => e.id !== id);

  dispatch({
    type: actionTypes.REMOVE_DRAFT,
    payload: {
      data: newArray,
    },
  });
};

export const saveNoteByCallId = (callId, note) => async (
  dispatch,
  getState
) => {
  try {
    if (callId && note) {
      const dateNow = lib.dayjs().format('YYYY-MM-DD HH:mm:ss');
      const { account_id, user_name, userIdCode } = getState().auth;
      const draftNotes = getState().draft.notes;

      dispatch({
        type: actionTypes.NOTES_STORE,
        payload: [
          ...draftNotes,
          {
            id: null,
            call_id: callId,
            note,
            account_id,
            user_id: userIdCode,
            user_name,
            note_time: dateNow,
          },
        ],
      });

      // Retuns noteId as a result of save notes
      await api.callNotes.post.registerNote({
        call_id: callId,
        call_note: note,
      });
    }
  } catch (err) {
    log.error('Failed to save note by call ID.', err);
  }
};

export const getNotesByCallId = (
  callId,
  sipCallId,
  originalSipCallId
) => async (dispatch, getState) => {
  try {
    if (!callId) return;

    const draftNotes = getState().draft.data;

    let callNotes = (
      await api.callNotes.get.noteInfo(callId, sipCallId, originalSipCallId)
    )?.data;

    if (!callNotes?.length) return;

    if (sipCallId || originalSipCallId) {
      // Rewrite notes call_id with as the app expected "final" callId instend of sipCallId
      callNotes = callNotes.map(noteInfo => ({
        ...noteInfo,
        call_id: callId,
      }));
    }

    // Notes related to other callIds
    const otherDraftNotes = draftNotes.filter(d => d.call_id !== callId);

    dispatch({
      type: actionTypes.NOTES_STORE,
      payload: [...callNotes, ...otherDraftNotes],
    });
  } catch (err) {
    log.error('Failed to fetch notes by call ID.', err);
  }
};

export const resetNotes = () => async dispatch => {
  dispatch({ type: actionTypes.NOTES_RESET });
};
